<template>
  <div>
    <SearchBox :labeltxt="labeltxt" :row="row">
      <v-textarea solo :value="value"
          @input="(value) => $emit('input', value)"
          :label="placeholder"
          :disabled="disabled"
          :background-color="bgColor"
          :rows="rows"
          :error-messages="errorsMsg"
          auto-grow
          :maxlength="max"
        >
      </v-textarea>
    </SearchBox>
  </div>
</template>

<script>
export default {
  name: 'DefaultTextarea',
  props: {
    type: {
      type: [String],
    },
    value: {
      type: [String, Number],
    },
    placeholder: {
      type: [String],
    },
    disabled: {
      type: [Boolean],
    },
    labeltxt: {
      type: [String],
      default() {
        return null;
      },
    },
    bgColor: {
      type: [String],
      default() {
        return '#ffffff';
      },
    },
    row: {
      type: [Boolean],
      default: false,
    },
    errorsMsg: {
      type: [String, Array],
    },
    max: {
      type: [String, Number],
      default() {
        return 524288;
      },
    },
    rows: {
      type: [String, Number],
      default() {
        return 3;
      },
    },
  },
  methods: {
    doKeyUp() {
      this.$emit('keyup');
    },
    doOnBlur() {
      this.$emit('doOnBlur');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
